import { render, staticRenderFns } from "./BldrRepeater.vue?vue&type=template&id=136bf87a"
import script from "./BldrRepeater.vue?vue&type=script&lang=js"
export * from "./BldrRepeater.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports